import React from "react";
import { useAppContext } from "../../context/AppContext";
import styles from "./style.module.scss";

const Footer = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  const { app } = useAppContext();

  const footerClass = isLoggedIn ? styles.loggedIn : styles.loggedOut;

  return (
    <footer className={`${styles.footer} ${footerClass}`}>
      <div className={styles.footerContent}>
        <span className={styles.copyright}>
          © {new Date().getFullYear()} Optenics. All rights reserved.
        </span>
        <span className={styles.version}>v1.0.0</span>
      </div>
    </footer>
  );
};

export default Footer;
